<template>
    <div class="h-100">
        <div class="titolo-sezioni-cart" v-if="!this.reservationMode">
            {{$t('carrello_mod_pagamento')}}
        </div>
        <div class="titolo-sezioni-cart text-left p-0 mb-3" v-if="this.reservationMode">
          {{$t('prenota_mod_pagamento')}}
        </div>
        <div :class="{'blocchetto-pagamenti h-100': !this.reservationMode}">
          <div class="row">
              <div class="col-6 col-md-4" v-if="this.is_new_card_enabled">
                <button type="button" class="btn btn-pagamento align-items-center text-center"
                        @click="onNewCardPress()">
                  <i class="pi pi-plus f22"></i><br>
                  <span>Nuova carta</span>
                </button>
              </div>
              <div class="col-6 col-md-4" v-for="item in this.items">
                  <button type="button" class="btn btn-pagamento d-flex flex-column"
                          @click.prevent="onItemPress(item)"
                         :class="{active: value === item.id }">
                    <a href="#" v-if="item.tipo === 'STRIPE_CARTACREDITO' && item.isFresh"
                       @click.stop.prevent="onDeletePress(item)">
                      <img src="/img/be/ico-delete-carta.png" height="20" class="my-2">
                    </a>
                    <span v-else>
                        <img :src="getIcoUrl(item)" height="20" class="my-2">
                    </span>
                    <span v-if="item.label" class="text-left">
                        {{item.label}}
                    </span>
                    <span v-else-if="item.info" class="f14">
                        <b class="text-capitalize">{{item.info.data.brand}} **** {{item.info.data.last4}}</b><br>
                        <span :class="{'text-danger': item.info.data.expired}">{{$t('scad')}} {{item.info.data.expMonth.toString().padStart(2, '0')}}/{{item.info.data.expYear}}
                        </span>
                    </span>
                </button>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "IncPaymentMode",
    props: ['items', 'value', 'reservationMode'],
    computed: {
        is_new_card_enabled: function () {
            const item = this.items.find((obj) => obj.tipo === 'STRIPE_CARTACREDITO');

            return !!(item && item.info);
        }
    },
    methods: {
        getIcoUrl: function (item) {
            let imageUrl = '/img/be/';

            switch (item.tipo) {
                case 'CONTANTI':
                    switch (item.tipo_mezzo) {
                        case 'CONTANTI':
                            imageUrl += 'ico-contanti.png';
                            break;
                        case 'CARTA_CREDITO':
                            imageUrl += 'ico-pagamento-consegna.png';
                            break;
                        case 'BUONI_PASTO':
                            imageUrl += 'ico-buoni-pasto.png';
                            break;
                    }
                    break;
                case 'STRIPE_CARTACREDITO':
                    imageUrl += 'ico-carta.png';
                    break;
            }

            return imageUrl;
        },
        onItemPress: function (item) {
            this.$emit('onItemPress', item)
        },
        onNewCardPress: function () {
            this.$emit('onNewCardPress');
        },
        onDeletePress: function (item) {
            this.$emit('onDeletePress', item);
        }
    }
}
</script>
